  <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-3 g-md-4 d-none">
    <!-- Total Forms Card -->
    <div class="col-md-4">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Total Questionnaire Forms</p>
              <p class="mb-0 text-primary-green fs-4">{{ total_forms }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-invoice text-primary fa-lg mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Forms Card -->
    <div class="col-md-4">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Pending Questionnaire Forms</p>
              <p class="mb-0 text-primary-green fs-4">{{ pending_forms }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-exclamation fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Approved Forms Card -->
    <div class="col-md-4">
      <div class="card card-bg shadow rounded-lg border-0 h-100">
        <div class="card-body p-3">
          <div class="d-flex flex-column flex-sm-row justify-content-between h-100">
            <div class="mb-3 mb-sm-0">
              <p class="text-white mb-1 fs-6">Submitted Questionnaire Forms</p>
              <p class="mb-0 text-primary-green fs-4">{{ submitted_forms }}</p>
            </div>
            <div class="text-center text-sm-end">
              <div class="p-1 p-md-2">
                <i class="fa-solid fa-file-circle-check fa-lg text-primary-green mb-2 mb-md-3"></i>
              </div>
              <a href="#" class="d-block text-primary-green text-decoration-none fs-6 fs-md-5">
                View
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Table Card - Responsive by default -->
  <div class="glassy-table border-0 rounded-lg mb-5">
      <div class="card-body p-3 p-md-4">
        <div class="table-responsive">
          <GlobalTable
            v-if="table_data.length"
            :headers="table_headers"
            :data="table_data"
            table_id="shared-forms-table"
          >
            <template #actions="{ row }">
              <button
                class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
                @click="view_form(row['Form ID'])"
              >
                View
              </button>
            </template>
          </GlobalTable>

          <div v-else class="empty-table-message text-center py-5">
            <p class="text-muted mb-0 text-xs">No questionnaires shared.</p>
          </div>
        </div>
      </div>
      <AICampusFooter/>
    </div>
 
